import { BiddingCsvRowStatus } from '@ebalance/proto/bffuser/v1/bidding_common_model_pb'

import { BidCsvConfirmRejection } from '~/components/bidding/common/BidCsvConfirmRejection'
import { BidCsvRowStatusBadge } from '~/pages/SpotCsvImport/components/PreviewTable'
import { parseConfirmRejection } from '~/pages/SpotCsvImport/models/confirmRejection'

type Props = {
  /** 確定 RPC が返した拒否理由 (改行区切り)。 */
  message: string
}

/**
 * 通常入札 CSV の確定時の再検証で取込全体が拒否されたときの、 確定モーダルのエラー表示
 * (Des 回答 #8786)。 表示は時間前入札と共有の `BidCsvConfirmRejection` で、 ここは
 * 拒否理由の文言を行ごとのエラーとファイル全体の理由に分けて渡すだけ。
 */
export const ConfirmRejection = ({ message }: Props): React.ReactElement => {
  const { rows, fileReasons } = parseConfirmRejection(message)

  return (
    <BidCsvConfirmRejection
      errorBadge={<BidCsvRowStatusBadge status={BiddingCsvRowStatus.ERROR} />}
      errorRowCount={rows.length}
      fileReasons={fileReasons}
      rowMessages={rows.map((row) => row.text)}
    />
  )
}
